import { Money } from '@libs/money/money.interfaces';

export interface Baggage {
    Description: string;
    Id: string;
    Index: number;
    IsSelected: boolean;
    PerSector: BaggagePerSector[] | null;
    Pieces: number;
    Price: Money;
    PriceBreakdown: BaggagePriceBreakdown;
    ShowDiscardPopUp: boolean;
    Type: BaggageType;
    Weight: number;
}

export interface UpSellBaggage extends Baggage {
    Leg: LegType;
}

export interface BaggageIncluded {
    PerSector: BaggagePerSector[] | null;
    Pieces: number;
    Type: BaggageType;
    TotalWeight: number;
}

export interface AdditionalBaggage {
    Alternatives: Baggage[];
    ShowWarning: boolean;
    SplitSector: boolean;
}

export interface BaggagePerSector {
    SectorNumber: number;
    Price?: number;
    Weight?: number;
    TotalPrice?: Money;
}

export interface BaggagePriceBreakdown {
    BaggagePrice: Money;
    BookingFee: Money;
    TotalPrice: Money;
}

export enum BaggageType {
    Unknown = 'Unknown',
    CheckedBag = 'CheckedBag',
    CabinBag = 'CabinBag',
    SmallBag = 'SmallBag',
}

export enum LegType {
    Outbound = 'Outbound',
    Inbound = 'Inbound',
    RoundTrip = 'RoundTrip',
}

export const NO_SELECTION = 'NO_SELECTION';

export interface IncludedBaggages {
    splitSector: boolean;
    baggages: BaggageIncluded[];
}
